import Backdrop from './Backdrop'
import  '../styles/modal.scss'

const Modal = ({handleClose, children}) => {
    return(
        <Backdrop>
            <div className="close-container" onClick={handleClose}>
                <img src="./img/ui/close-btn.png" alt="X"/>
            </div>
            {children}
        </Backdrop>
    )
}
export default Modal;